/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelcomposetitle2Inputs */

const en_channelcomposetitle2 = /** @type {(inputs: Channelcomposetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New announcement`)
};

const de_channelcomposetitle2 = /** @type {(inputs: Channelcomposetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ankündigung`)
};

/**
* | output |
* | --- |
* | "New announcement" |
*
* @param {Channelcomposetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelcomposetitle2 = /** @type {((inputs?: Channelcomposetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelcomposetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelcomposetitle2(inputs)
	return de_channelcomposetitle2(inputs)
});
export { channelcomposetitle2 as "channelComposeTitle" }